module.exports = "/_next/static/fonts/founders-grotesk-x-condensed-web-medium-1263a35297e7304939844c0c0ef9dfd7.woff2";